"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _loading = _interopRequireDefault(require("./loading.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  animationData: _loading["default"],
  animationKey: 'loading'
};
exports["default"] = _default;